import { useTheme } from "../../theme";

interface ThemeToggleProps {
  placement: "header" | "sidebar";
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ placement }) => {
  const { theme, toggleTheme } = useTheme();
  const nextLabel = theme === "dark" ? "Activar modo claro" : "Activar modo oscuro";

  if (placement === "sidebar") {
    return (
      <label className="theme-sidebar-toggle">
        <span className="theme-sidebar-toggle-label">
          <i className={`fa-solid fa-${theme === "dark" ? "moon" : "sun"}`} aria-hidden="true" />
          <span>Tema</span>
        </span>
        <input
          type="checkbox"
          role="switch"
          checked={theme === "dark"}
          onChange={toggleTheme}
          aria-label={nextLabel}
        />
        <span className="theme-sidebar-toggle-track" aria-hidden="true">
          <span className="theme-sidebar-toggle-thumb" />
        </span>
      </label>
    );
  }

  return (
    <button
      type="button"
      className={`theme-toggle theme-toggle-${placement}`}
      onClick={toggleTheme}
      aria-label={nextLabel}
      title={nextLabel}
    >
      <i className="fa-solid fa-sun theme-toggle-icon theme-toggle-icon-sun" aria-hidden="true" />
      <i className="fa-solid fa-moon theme-toggle-icon theme-toggle-icon-moon" aria-hidden="true" />
    </button>
  );
};

export default ThemeToggle;
